import type DropdownItem from './dropdown-item';
import { SelectList } from '@acies/core';
import DropdownItemRenderer from './dropdown-item-renderer';

/** The DropdownList is responsible for rendering the DropdownItems in the data property Array or ObservableCollection. */
export default class DropdownList extends SelectList<DropdownItem> {
	public constructor() {
		super();
		this.paddingHorizontal = 4;
		this.paddingVertical = 4;
		this.width = 'fill';
		this.gapVertical = 4;
		this.ItemRenderer = DropdownItemRenderer;
	}

	/**
	 * Lays the list out as a block rather than inline, so it is as wide as the popover it sits in.
	 *
	 * The Dropdown's popover is a plain div rather than a Container, because a Container writes its own display over the one the popover API hides a closed popover with. A plain div is no flex parent, so `width = 'fill'` has nothing to fill, and an inline-flex list shrinks to its widest item. Block level is what
	 * stretches it instead. Inside a Container, where PopoverContainer puts one, it makes no difference: a flex item is laid out as a block whichever it asks for.
	 *
	 * Written after the rest of the commit, since that is where Container writes display, whenever visible or autoLayout changes.
	 */
	protected override commitProperties(): void {
		super.commitProperties();
		if (this.visible) {
			this.style.display = 'flex';
		}
	}
}
customElements.define('ac-dropdown-list', DropdownList);
